import { differenceInDays, format, subDays } from 'date-fns'
import { format as timeZoneFormat, utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz'

const CENTRAL_TIME_ZONE = 'America/Chicago'
const EASTERN_TIME_ZONE = 'America/New_York'

export const isDateBeforeToday = (dateInQuestion: string) => {
  const today = new Date()
  return differenceInDays(today, new Date(dateInQuestion)) > 0
}
export const isDateAfterToday = (dateInQuestion: string) => {
  const today = format(new Date(), 'MM/dd/yyyy')
  return isOneDateBeforeAnotherDate(today, dateInQuestion)
}

export const isOneDateBeforeAnotherDate = (oneDate: string, anotherDate: string) =>
  differenceInDays(new Date(anotherDate), new Date(oneDate)) > 0

export const yesterday = () => format(subDays(new Date(), 1), 'MM/dd/yyyy')

export const formatCentralDateToEastern = (centralDateTime: string) => {
  const utcDate = zonedTimeToUtc(centralDateTime, CENTRAL_TIME_ZONE)
  const zonedDate = utcToZonedTime(utcDate, EASTERN_TIME_ZONE)
  return timeZoneFormat(zonedDate, 'MM/dd/yyyy HH:mm:ss zzz', { timeZone: EASTERN_TIME_ZONE })
}
